import { useState } from "react";

/* API */
import { api } from '../../api';

/* CSS */
import shared from '../../styles/shared.module.css';
import styles from './AccountSettings.module.css';

/* Confirmation Card */
import ConfirmationModal from '../cards/ConfirmationModal';

/* Utils */
import { validatePassword } from '../../utils/passwordUtils';

/* Context */
import { useAuthContext } from "../../context/AuthContext";

/* Password component */
import PasswordInput from "../auth/PasswordInput";
import PasswordChecklist from '../../components/auth/PasswordChecklist';

/* Icons */
import success_icon from '../../assets/icons/success_icon.svg';

const AccountSettings = () => {

    const { currentUser } = useAuthContext();

    // Password types
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    // Success save modal
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    // Loading state for the save button
    const [isLoading, setIsLoading] = useState(false);

    // Check validation on every keystroke
    const criteria = validatePassword(newPassword, confirmPassword);
    const isFormValid = Object.values(criteria).every(Boolean) &&
        (!currentUser.has_password || oldPassword !== '');

    const handleSave = async () => {
        if (isFormValid) {
            try {
                setIsLoading(true);
                await api.patch('/auth/change-password', {
                    email: currentUser.email,
                    oldPassword,
                    newPassword
                });

                setShowSuccessModal(true);

                // Clear fields
                setOldPassword('');
                setNewPassword('');
                setConfirmPassword('');
            } catch (err) {
                alert(err.message || "Failed to change password. Please try again.")
            } finally {
                setIsLoading(false);
            }
        }
    }

    return (
        <div>
            <div className={styles.accountForm}>

                {currentUser.has_password &&
                    /* Old Password */
                    <div style={{ marginBottom: '28px' }}>
                        <PasswordInput
                            label="Old Password"
                            value={oldPassword}
                            onChange={setOldPassword}
                        />
                    </div>
                }

                {/* New Password */}
                <div>
                    <PasswordInput
                        label="New Password"
                        value={newPassword}
                        onChange={setNewPassword}
                    />

                    {/* Valid criteria */}
                    <PasswordChecklist criteria={criteria} />
                </div>

                {/* Confirm Password */}
                <div>
                    <div>
                        <PasswordInput
                            label="Confirm New Password"
                            value={confirmPassword}
                            onChange={setConfirmPassword}
                        />
                    </div>

                    {/* Match criteria */}
                    <PasswordChecklist criteria={criteria} isConfirmPassword={true} />
                </div>

                {/* Save Button */}
                <div className={shared.formActions}>
                    <button
                        className={`${shared.saveSettingsButton} ${isLoading ? shared.buttonLoading : ''}`}
                        onClick={handleSave}
                        disabled={!isFormValid || isLoading}
                    >
                        <div className={shared.buttonContent}>
                            {isLoading ? "Saving..." : "Save"}
                            {isLoading && <span className={shared.spinner}></span>}
                        </div>
                    </button>
                </div>
            </div>

            {/* --- MODAL: SUCCESS --- */}
            <ConfirmationModal
                isOpen={showSuccessModal}
                message="Your password has been successfully changed."
                onClose={() => setShowSuccessModal(false)}
                onConfirm={() => setShowSuccessModal(false)}
                confirmText="Dismiss"
                showCancel={false}
                isSuccess={false}
                customIcon={<img src={success_icon} alt="Success" />}
            />
        </div>
    );
};

export default AccountSettings;